$('.p-tab-01 .tab-ope').on('click',function(){

  var $tab_wrap = $(this).parents('.p-tab-01').first();

  $tab_wrap.find('.tab-ope').removeClass('js-selected');
  $(this).addClass('js-selected');
  var $tabw = $tab_wrap.data('tabw');
  var $childtab = $(this).data('childtab');

  $('#'+$tabw).find('.tab-contents-inner').removeClass('js-active');
  $('#'+$tabw).find('.tab-contents-inner.'+$childtab).addClass('js-active');

});

$(window).on('load', function() {
  var tab_num = $('.p-tab-01').length;
  for(var i = 0; tab_num > i; i++){
    $('.p-tab-01').eq(i).find('.tab-ope').first().click();
  }
});